module.exports = __webpack_public_path__ + "img/IMG_9519_L_Black_MockedUp.0e3ade21.jpg";